var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"count__banner"}},[_c('div',{staticClass:"count__banner-text"},[_c('span',{ref:"count-text",attrs:{"id":"count-text"}},[_vm._v("s")]),_c('span',{ref:"count-num",attrs:{"id":"count-num"}},[_vm._v("s")])])])}
var staticRenderFns = []

export { render, staticRenderFns }